import { OnboardingDocumentSubmissionsList } from '@/components/OnboardingDocumentSubmissionsList';
import { OnboardingDocumentTemplatesList } from '@/components/OnboardingDocumentTemplatesList';
import TabLayout from '@/components/TabLayout';
import React from 'react';
import { Link, useLocation } from 'react-router';
import { Menu } from 'semantic-ui-react';

export const OnboardingDocuments = () => {
  const { pathname } = useLocation();

  return (
    <TabLayout
      linkTitle="Onboarding Documents"
      panes={panes}
      path={pathname}
      activeBreadcrumb="Onboarding Documents"
    />
  );
};

const panes = [
  {
    route: 'templates',
    menuItem: (
      <Menu.Item as={Link} to="/onboarding/documents/templates" key="templates">
        Templates
      </Menu.Item>
    ),
    render: () => <OnboardingDocumentTemplatesList />,
  },
  {
    route: 'submissions',
    menuItem: (
      <Menu.Item as={Link} to="/onboarding/documents/submissions" key="submissions">
        Submissions
      </Menu.Item>
    ),
    render: () => <OnboardingDocumentSubmissionsList />,
  },
];
